import { createTheme } from "@mui/material"

export const theme = createTheme({
    typography: {
        fontFamily: "MarkPro,sans-serif",
    },
    palette: {
        primary: {
            main: "#101941",
        },
        secondary: {
            main: "#FC441E",
        },
    },

    components: {
        MuiButton: {
            styleOverrides: {
                root: ({ ownerState }) => ({
                    ...((ownerState.variant === "contained" || ownerState.variant === "primaryContained") && {
                        background: "linear-gradient(180deg, #FC441E 0%, #FE5567 100%)",
                        color: "#fff",
                    }),
                    text: {
                        textTransform: "none",
                    },
                    "&.Mui-disabled": {
                        color: "#ffffff",
                        opacity: "0.6",
                    },
                }),
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: "6px",
                    background: "#F5F6F7",
                    position: "relative",
                    border: "none",
                    height: "43px",
                    "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "transparent",
                    },
                    "&.Mui-disabled": {
                        color: "#101941",
                    },
                    "&:focus .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#101941",
                        borderWidth: 2,
                    },
                    "&:hover:not(.Mui-disabled):not(.Mui-error) .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#101941",
                    },
                },

                input: {
                    padding: "12px",
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: "grey",
                    textTransform: "none",
                    fontSize: 12,
                    top: -2,
                    "&.Mui-disabled": {
                        color: "#101941",
                    },
                },
            },
        },
        MuiFormControl: {
            styleOverrides: {
                root: {
                    width: "100%",
                },
            },
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    color: "#101941",
                    fontSize: 14,
                    marginBottom: 8,
                },
            },
        },
        MuiFormControlLabel: {
            styleOverrides: {
                root: {
                    fontSize: 12,
                    color: "#101941",
                },
            },
        },
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1536,
            desktop_sm: 1280,
            laptop: 1440,
            desktop_md: 1536,
            desktop_lg: 1920,
        },
    },
})
